// src/hooks/useClients.js
import { useState } from "react";
import { useAuth } from "./";
import {
  getClientsApi,
  getClientByIdApi,
  createClientApi,
  updateClientApi,
  deleteClientApi,
} from "../api/clients";

export function useClients() {
  const { auth } = useAuth();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [clients, setClients] = useState([]);

  const getClients = async (params) => {
    try {
      setLoading(true);
      const data = await getClientsApi(auth.token, params);
      setClients(data);
      setLoading(false);
      return data;
    } catch (err) {
      setLoading(false);
      setError(err);
      throw err;
    }
  };

  const getClientById = async (id) => {
    try {
      setLoading(true);
      const data = await getClientByIdApi(id, auth.token);
      setLoading(false);
      return data;
    } catch (err) {
      setLoading(false);
      setError(err);
      throw err;
    }
  };

  const newClient = async (payload) => {
    try {
      setLoading(true);
      const data = await createClientApi(payload, auth.token);
      setLoading(false);
      return data;
    } catch (err) {
      setLoading(false);
      setError(err);
      throw err;
    }
  };

  const editClient = async (id, payload) => {
    try {
      setLoading(true);
      const data = await updateClientApi(id, payload, auth.token);
      setLoading(false);
      return data;
    } catch (err) {
      setLoading(false);
      setError(err);
      throw err;
    }
  };

  const removeClient = async (id) => {
    try {
      setLoading(true);
      await deleteClientApi(id, auth.token);
      setLoading(false);
      return true;
    } catch (err) {
      setLoading(false);
      setError(err);
      throw err;
    }
  };

  return {
    loading,
    error,
    clients,
    getClients,
    getClientById,
    newClient,
    editClient,
    removeClient,
  };
}
